import React from "react";
import Modal from "react-modal";
import moment from "moment";
import { ReactComponent as CloseIcon } from "../../../../../assets/icons/CloseIcon.svg";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import { useSelector } from "react-redux";
import { getFullName } from "../../../../../util/helpers";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "50%",
  },
};

export const SingleNoteView = ({ title, data }) => {
  const { staffData } = useSelector((state) => state.app);

  const getManagedBy = (id) => {
    const added_by_staff = staffData?.find((staff) => {
      if (staff?.id === id) {
        return staff;
      }
    });
    return getFullName(added_by_staff) || "Not available";
  };
  return (
    <CardLayout className="p-3">
      <div className="container-fluid">
        <h3>{title}</h3>
        <br />
        <br />
        <div className="container-fluid w-100 my-2 px-3">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <small className="muted-text">Creator</small>
              <h5 className="primary-text" style={{ textAlign: "start" }}>
                {getManagedBy(data?.added_by)}
              </h5>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">
              <small className="muted-text">Date written</small>
              <h5 className="primary-text" style={{ textAlign: "start" }}>
                {moment(data?.modified).format("MMM, DD, YYYY - HH:mma")}
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <small className="muted-text">Activity</small>
              <h4 className="primary-text" style={{ textAlign: "start" }}>{data?.activity}</h4>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">
              <small className="muted-text">Duration</small>
              <h4 className="primary-text" style={{ textAlign: "start" }}>{data?.duration}</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <small className="muted-text">Month</small>
              <h4 className="primary-text" style={{ textAlign: "start" }}>{data?.month}</h4>
            </div>
            </div>
          <br />
          <div className="my-2">
            <span className="muted-text">Note</span>
            <textarea
              className="entry-textarea mt-2"
              readOnly
              style={{ height: "25vh", color: "#333" }}
              value={data?.notes || "N / A"}
            />
          </div>
        </div>
      </div>
    </CardLayout>
  );
};

const NotesModal = ({
  modalIsOpen,
  setIsOpen,
  data,
  modalTitle = "View Note",
}) => {
  Modal.setAppElement("#root");
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel=""
    >
      <div className="container-fluid">
        <button
          style={{
            position: "absolute",
            right: "15px",
            border: "0px",
            fontFamily: "DM Sans",
            backgroundColor: "transparent",
          }}
          onClick={closeModal}
        >
          <CloseIcon />
        </button>
        <SingleNoteView title={modalTitle} data={data} />
      </div>
    </Modal>
  );
};

export default NotesModal;
